import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  Button,
  IconButton,
  Card
} from "@mui/material";
import { UserEdit, Sms, User } from "iconsax-react"; 
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";


const GuestEditModal = ({
  isOpen,
  handleClose,
  selectedRow,
  changeFormValue,
  onSave, // Add the onSave function as a prop
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="xs"> {/* Set maxWidth to 'xs' */}
      <Box sx={{ padding: "16px", width: '100%' }}> {/* Reduced padding here */}
        <DialogTitle sx={{ position: 'relative', display: 'flex', flexDirection: 'column', padding: '10px 16px 0', marginBottom: '20px' }}>
          <Card sx={{ 
              width: 'fit-content',
              display: 'flex', 
              alignItems: 'center', 
              padding: '10px', 
              border: '1px solid #EAECF0', 
              borderRadius: '8px', // Rounded corners for the card
              marginBottom: '10px',
              backgroundColor: '#fff' // White background for the card
            }}>
            <UserEdit sx={{ color: '#000', fontSize: 24 }} /> {/* Using UserEdit icon */}
          </Card>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '18px' }}>
              {t("Edit Guest")}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 300,
                color: "#475467",
                marginTop: "0px",
              }}
            >
              {t("Make adjustments to the guest data")}
            </Typography>
          </Box>
          {/* Close button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 0,
              top: 0,
              color: 'rgba(0, 0, 0, 0.54)',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: "16px 16px 16px 16px" }}> {/* Smaller padding for content */}
          <Grid container gap={1}>
            <Grid item sm={12}>
              <FormControl fullWidth>
                <InputLabel>Name</InputLabel>
                <Input
                  type="text"
                  placeholder="Full Name"
                  disabled
                  startAdornment={
                    <InputAdornment position="start">
                      <User sx={{ color: '#4AA1B3' }} /> {/* Normal user icon for Name from iconsax */}
                    </InputAdornment>
                  }
                  name="name"
                  defaultValue={selectedRow?.name}
                  onChange={(e) => changeFormValue("name", e.target.value)}
                  style={{cursor: 'disable'}}
                />
              </FormControl>
            </Grid>
            <Grid item sm={12}>
              <FormControl fullWidth>
                <InputLabel>Email</InputLabel>
                <Input
                  type="text"
                  placeholder="example@mail.com"
                  required
                  startAdornment={
                    <InputAdornment position="start">
                      <Sms size={22} /> {/* Sms icon for Email */}
                    </InputAdornment>
                  }
                  name="email"
                  defaultValue={selectedRow?.Email_Guest__c}
                  onChange={(e) => changeFormValue("Email_Guest__c", e.target.value)}
                />
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between", display: "flex", padding: "8px 16px", marginTop: '16px' }}> {/* Smaller padding for buttons */}
          <Box sx={{ flex: 1, mr: 1 }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              fullWidth // Make Cancel button take full width
              sx={{
                height: "48px", // Ensure the height matches the Save button
                borderRadius: "8px",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "16px", marginRight: "5px" }}>
                {t("Cancel")}
              </Typography>
            </Button>
          </Box>
          <Box sx={{ flex: 1, ml: 1 }}>
            <Button
              onClick={onSave}
              variant="contained"
              sx={{
                background: "#2F37B5",
                borderRadius: "8px",
                height: "48px", // Match height
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              disabled={isLoading} 
              fullWidth
            >
              <Typography sx={{ color: "white", fontWeight: 600, fontSize: "16px", marginRight: "5px" }}>
                {t("Save")}
              </Typography>
            </Button>
          </Box>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

GuestEditModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectedRow: PropTypes.object.isRequired,
  changeFormValue: PropTypes.func,
  onSave: PropTypes.func.isRequired, // Add onSave prop type
  isLoading: PropTypes.bool, // Add loading state prop type
};

export default GuestEditModal;